import { Box } from '@mui/material'
import React from 'react'
import logo1 from '../../images/logo1.png'
import logo2 from '../../images/logo2.png'

function Logo() {
  return (
    <Box sx={{ display: "flex", mr: 1 }}>
  <Box
    component="img"
    src={logo1}
    alt="Logo 1"
    sx={{
      width: { xs: 24, sm: 40 },
      height: { xs: 24, sm: 40 },
    }}
  />
  <Box
    component="img"
    src={logo2}
    alt="Logo 2"
    sx={{
      width: { xs: 80, sm: 160 },
      height: { xs: 24, sm: 40 },
      ml: 1,
    }}
  />
</Box>

  )
}

export default Logo
